// @flow

import topic from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Topic';
import newOrExistingAppChild from './newOrExisting';
import noAppYetChild from './noAppYet';

const developerPlatform = topic({
  zendeskCustomFieldId: 360044601391, // You may need to update this ID
  label: 'What do you need help with?',
  items: [
    {
      value: 'existing',
      icon: 'miscBolt',
      label: 'Help with an existing integration',
      child: newOrExistingAppChild,
      zendeskCustomFieldValue: 'pcf-existing',
    },
    {
      value: 'building',
      icon: 'personCircleFill',
      label: 'Help with a new integration',
      child: noAppYetChild,
      zendeskCustomFieldValue: 'pcf-new',
    },
  ],
});

export default developerPlatform;
